module.exports = __webpack_public_path__ + "img/horizontal_1_1_7005.fe0d8147.png";